<template>
    <v-dialog v-model="isActive" width="400px" transition="dialog-bottom-transition">
        <v-card class="rounded-0">
            <v-card flat class="rounded-0">
                <v-app-bar flat color="white" height="50" class="ma-2">
                    <v-btn icon @click="cerrar()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title class="pr-1 text-h6 font-weight-bold primary--text"
                        style="white-space: normal; word-break: break-word;">Cancelar {{
                            tipo.substring(0, tipo.length - 1) }}</v-toolbar-title>
                </v-app-bar>
            </v-card>
            <!--             <v-card-title class="font-weight-bold text-h5 red--text justify-center">Cancelar {{
                tipo.substring(0, tipo.length - 1) }}</v-card-title> -->
            <v-card-text v-if="tipo == 'turnos'"
                class="d-flex justify-center font-weight-regular black--text text-center text-body-1 ">
                ¿Querés cancelar el turno?
            </v-card-text>
            <v-card-actions class="ma-0 pa-0">
                <v-col cols="12" md="12" class="d-flex flex-column align-center">
                    <v-btn @click="cancelar" dark elevation="0" width="200" :loading="loading" class="pa-5"
                        color="primary">
                        Si, cancelar
                    </v-btn>
                    <v-btn @click="cerrar()" color="secondary" outlined elevation="0" width="200" class="mt-1 pa-5">
                        cerrar
                    </v-btn>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TurnoCard from '@/components/cards/TurnoCard.vue'
export default {
    data() {
        return {
            isActive: false,
        }
    },
    components: {
        TurnoCard,
    },
    methods: {
        ...mapActions('turnos', ['cancelarTurno']),
        ...mapActions(['sendTelefono', 'sendDomicilio', 'sendEmail', 'sendFamiliar']),
        ...mapActions('dataUser', ['modificarFamiliar']),

        ...mapMutations('turnos', ['setNuevoTurno']),

        lanzar() {
            this.isActive = true
        },
        cancelar() {
            this.cancelarTurno({ thd_id: this.turnosActivos.thd_id })
                .then(() => {
                    this.isActive = false
                    this.setNuevoTurno(false)
                    //  this.$router.push('/dashboard').catch(() => { })
                })
        },
        cerrar() {
            this.isActive = false
            //this.setNuevoTurno(false)
        },
    },
    computed: {
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('turnos', ['turnosActivos', 'nuevoTurno']),
        ...mapGetters('itemEdit', ['itemSelected', 'indiceSelected']),
        ...mapGetters('auth', ['nroafi']),
    },
    props: ['accion', 'tipo']
}

</script>